var _style, _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoHm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 986.5 283.5",
    style: {
      enableBackground: "new 0 0 986.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#004E2B;}\n\t.st1{fill:#00DD39;}\n\t.st2{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.5,283.5H109c-65.4,0-109-43.6-109-109V0h174.4c65.4,0,109,43.6,109,109V283.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.6,98.1h21.8c40.7,0,65.4,24.8,65.4,65.4v76.3H218c-40.1,0-65.4-25.6-65.4-65.4V98.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.6,43.6h87.2v196.2H109c-40.5,0-65.4-24.5-65.4-65.4V43.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348.9,239.9V158H365l27.5,41.1l27.9-41.1h15.7v81.8H419v-53.1L396.2,220h-7.5l-22.8-33.2v53.1H348.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M446.7,208.8c0-18.2,14-32.3,32.3-32.3c10.3,0,17.4,4.3,21.3,9.3l0.4-8.2h15.3v62.2h-15.3l-0.4-8.2 c-3.9,5-11,9.3-21.3,9.3C460.7,241,446.7,227,446.7,208.8z M481.4,227.6c10.6,0,18.8-8.1,18.8-18.8c0-10.5-8.2-18.8-18.8-18.8 c-10.6,0-18.8,8.3-18.8,18.8C462.6,219.5,470.8,227.6,481.4,227.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M538.3,192.2h-14.3v-14.5h14.3v-16.9h16.1v16.9h22.7v14.5h-22.7v21.3c0,7.9,4,11.9,11.9,11.9h10.8v14.5h-13.6 c-16.6,0-25.2-8.6-25.2-25.2V192.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M584,208.8c0-19.2,14.3-32.3,32.5-32.3c19.6,0,32.3,13.1,32.3,32.3c0,2.3,0,3.2-0.2,6.7h-47.7 c1.8,6.8,7.5,12.3,17.8,12.3c7.8,0,12.4-2.1,16.8-6.8l10.1,10.1c-5.6,5.1-13.6,10.1-27.6,10.1C596.1,241,584,227.9,584,208.8z  M632.6,202.3c-0.9-6.5-6.1-12.5-15.4-12.5c-10.2,0-15.2,6.1-16.8,12.5H632.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M659.2,239.9v-35.3c0-16.4,10.5-26.9,26.9-26.9h14.5v14.5h-10.8c-10.3,0-14.5,4.2-14.5,14.5v33.2H659.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M708.3,155.9c0-5.4,3.6-9.1,9.7-9.1c6.1,0,9.7,3.7,9.7,9.1s-3.6,9.1-9.7,9.1 C711.9,165.1,708.3,161.3,708.3,155.9z M709.9,239.9v-62.1H726v62.1H709.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M736.7,208.8c0-18.2,14-32.3,32.3-32.3c10.3,0,17.4,4.3,21.3,9.3l0.4-8.2h15.3v62.2h-15.3l-0.4-8.2 c-3.9,5-11,9.3-21.3,9.3C750.7,241,736.7,227,736.7,208.8z M771.4,227.6c10.6,0,18.8-8.1,18.8-18.8c0-10.5-8.2-18.8-18.8-18.8 c-10.6,0-18.8,8.3-18.8,18.8C752.6,219.5,760.7,227.6,771.4,227.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M819.3,239.9v-86.5h16.1v86.5H819.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M843.8,230.5l10.1-10.1c4.7,4.7,13.6,7.5,22.2,7.5c8.9,0,12.4-1.9,12.4-5.1c0-3.5-3.5-5.1-17.2-7.7 c-16-3-25.5-7.9-25.5-19.6c0-12.2,12.5-18.9,28.6-18.9c13.6,0,23.4,4.6,28.9,10.1l-10.1,10.1c-3.7-3.7-10.4-7-19.1-7 c-7.9,0-12.3,1.9-12.3,5.1c0,3.3,2.9,4.7,17.9,7.7c14.5,2.9,24.8,7.5,24.8,19.6c0,12.2-11.1,18.9-29.6,18.9 C859.8,241,849.9,236.6,843.8,230.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M405.7,125.4V92.7h-39.7v32.7h-17.1V43.6h17.1V77h39.7V43.6h17.1v81.8H405.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M433.4,94.3c0-19.2,14.3-32.3,32.5-32.3c19.6,0,32.3,13.1,32.3,32.3c0,2.3,0,3.2-0.2,6.7h-47.7 c1.8,6.8,7.5,12.3,17.8,12.3c7.8,0,12.4-2.1,16.8-6.8l10.1,10.1c-5.6,5.1-13.6,10.1-27.6,10.1C445.4,126.6,433.4,113.5,433.4,94.3 z M482,87.9c-0.9-6.5-6.1-12.5-15.4-12.5c-10.2,0-15.2,6.1-16.8,12.5H482z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M507.4,41.5c0-5.4,3.6-9.1,9.7-9.1c6.1,0,9.7,3.7,9.7,9.1s-3.6,9.1-9.7,9.1C511,50.6,507.4,46.9,507.4,41.5z  M509,125.4V63.4h16.1v62.1H509z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M588.8,38.9H605v86.5h-15.3l-0.4-8.2c-3.9,5-11,9.3-21.3,9.3c-18.2,0-32.3-14-32.3-32.3s14-32.3,32.3-32.3 c9.9,0,16.8,4,20.8,8.8V38.9z M570.5,113.1c10.6,0,18.8-8.1,18.8-18.8c0-10.5-8.2-18.8-18.8-18.8s-18.8,8.3-18.8,18.8 C551.7,105.1,559.8,113.1,570.5,113.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M615.1,94.3c0-19.2,14.3-32.3,32.5-32.3c19.6,0,32.3,13.1,32.3,32.3c0,2.3,0,3.2-0.2,6.7h-47.7 c1.8,6.8,7.5,12.3,17.8,12.3c7.8,0,12.4-2.1,16.8-6.8l10.1,10.1c-5.6,5.1-13.6,10.1-27.6,10.1C627.2,126.6,615.1,113.5,615.1,94.3 z M663.7,87.9c-0.9-6.5-6.1-12.5-15.4-12.5c-10.2,0-15.2,6.1-16.8,12.5H663.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M690.3,125.4V38.9h16.1v86.5H690.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M736,70.8c4-4.8,10.9-8.8,20.8-8.8c18.2,0,32.3,14,32.3,32.3s-14,32.3-32.3,32.3c-10.3,0-17.4-4.3-21.3-9.3 l-0.4,8.2h-15.3V38.9H736V70.8z M754.3,75.5c-10.6,0-18.8,8.3-18.8,18.8c0,10.8,8.2,18.8,18.8,18.8c10.6,0,18.8-8.1,18.8-18.8 C773.1,83.8,765,75.5,754.3,75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M796.4,94.3c0-19.2,14.3-32.3,32.5-32.3c19.6,0,32.3,13.1,32.3,32.3c0,2.3,0,3.2-0.2,6.7h-47.7 c1.8,6.8,7.5,12.3,17.8,12.3c7.8,0,12.4-2.1,16.8-6.8l10.1,10.1c-5.6,5.1-13.6,10.1-27.6,10.1C808.4,126.6,796.4,113.5,796.4,94.3 z M845,87.9c-0.9-6.5-6.1-12.5-15.4-12.5c-10.2,0-15.2,6.1-16.8,12.5H845z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M871.5,125.4V90.1c0-16.4,10.5-26.9,26.9-26.9h14.5v14.5h-10.8c-10.3,0-14.5,4.2-14.5,14.5v33.2H871.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M921.6,140.8l10.1-10.1c5,5,10.9,8.2,21.4,8.2s17.3-6.8,17.3-17.3v-3.9c-4,4.8-10.9,8.8-20.8,8.8 c-18.2,0-32.3-14-32.3-32.3s14-32.3,32.3-32.3c10.3,0,17.4,4.3,21.3,9.3l0.4-8.2h15.3V120c0,19.9-13.6,32.3-33.4,32.3 C937.8,152.3,927.4,147.2,921.6,140.8z M952,113.1c10.6,0,18.8-8.1,18.8-18.8c0-10.5-8.2-18.8-18.8-18.8 c-10.6,0-18.8,8.3-18.8,18.8C933.2,105.1,941.3,113.1,952,113.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHm);
export default __webpack_public_path__ + "static/media/Logo-HM.9139519a32d36df04f235c3d3f709d82.svg";
export { ForwardRef as ReactComponent };